/* eslint-disable react-native/no-inline-styles */
import React from 'react';
import * as S from './styles';
// import CountDown from 'react-native-countdown-component';
import {useSelector} from 'react-redux';
import {RootState} from '../../store';
import TextDefault from '../TextDefault';
import theme from '../../global/styles/theme';
import {toPrice} from '../../utils/functions';
import Button from '../Button';
import {addHours, differenceInSeconds, lightFormat} from 'date-fns';
import {Linking, TouchableOpacity} from 'react-native';

interface TextDefaultProps {
  item: any;
  acceptTrade: (item: any) => void;
  applyBid?: () => void;
  isLoading: boolean;
}

function GavelItem(props: TextDefaultProps) {
  const {item, acceptTrade, applyBid, isLoading} = props;

  const userInfo = useSelector((state: RootState) => state?.user?.user);
  const appTheme = useSelector((state: RootState) => state.config.appTheme);

  const timeGavel = differenceInSeconds(
    addHours(new Date(item?.offers_end_at), 3),
    new Date(),
  );

  return (
    <S.Item appTheme={appTheme}>
      <S.Row>
        <TouchableOpacity
          style={{padding: 10}}
          onPress={() =>
            Linking.openURL(`https://dsstoken.com/token?id=${item.token_id}`)
          }>
          <TextDefault
            fontSize={14}
            color={theme.colors(appTheme).white}
            text={item.token_name}
            fontFamily={theme.fonts.family.opensans.semi_bold}
          />
        </TouchableOpacity>
        <S.ImageToken
          source={{
            uri: item?.token_logo,
          }}
          resizeMode="contain"
        />
      </S.Row>
      <S.Column style={{gap: 5}}>
        <S.Row>
          <TextDefault
            fontSize={12}
            color={theme.colors(appTheme).white}
            text="Tipo do leilão"
            fontFamily={theme.fonts.family.opensans.regular}
          />
          <TextDefault
            fontSize={10}
            color={theme.colors(appTheme).white}
            text={item?.type}
            fontFamily={theme.fonts.family.opensans.semi_bold}
          />
        </S.Row>
        {item.type === 'oferta' ? (
          <>
            <S.Row>
              <TextDefault
                fontSize={12}
                color={theme.colors(appTheme).white}
                text="Lance mín."
                fontFamily={theme.fonts.family.opensans.regular}
              />
              <TextDefault
                fontSize={10}
                color={theme.colors(appTheme).white}
                text={`R$ ${toPrice(item.min_value || 0, 2)}`}
                fontFamily={theme.fonts.family.opensans.semi_bold}
              />
            </S.Row>
          </>
        ) : (
          <>
            <S.Row>
              <TextDefault
                fontSize={12}
                color={theme.colors(appTheme).white}
                text="Valor unitário"
                fontFamily={theme.fonts.family.opensans.regular}
              />
              <TextDefault
                fontSize={10}
                color={theme.colors(appTheme).white}
                text={`R$ ${toPrice(item.value_unity || 0, 2)}`}
                fontFamily={theme.fonts.family.opensans.semi_bold}
              />
            </S.Row>
            <S.Row>
              <TextDefault
                fontSize={12}
                color={theme.colors(appTheme).white}
                text="Valor total do lote"
                fontFamily={theme.fonts.family.opensans.regular}
              />
              <TextDefault
                fontSize={10}
                color={theme.colors(appTheme).white}
                text={`R$ ${toPrice(
                  (item.value_unity || 1) * (item.qtd || 1),
                  2,
                )}`}
                fontFamily={theme.fonts.family.opensans.semi_bold}
              />
            </S.Row>
          </>
        )}
        <S.Row>
          <TextDefault
            fontSize={12}
            color={theme.colors(appTheme).white}
            text="Qtd. disponível"
            fontFamily={theme.fonts.family.opensans.regular}
          />
          <TextDefault
            fontSize={10}
            color={theme.colors(appTheme).white}
            text={item.qtd || 0}
            fontFamily={theme.fonts.family.opensans.semi_bold}
          />
        </S.Row>
        <S.Row>
          <TextDefault
            fontSize={12}
            color={theme.colors(appTheme).white}
            text="Tipo de token"
            fontFamily={theme.fonts.family.opensans.regular}
          />
          <TextDefault
            fontSize={10}
            color={theme.colors(appTheme).white}
            text={item.token_remuneration_period}
            fontFamily={theme.fonts.family.opensans.semi_bold}
          />
        </S.Row>
        {!item.appreciation ? null : (
          <S.Row>
            <TextDefault
              fontSize={12}
              color={theme.colors(appTheme).white}
              text="Valorização"
              fontFamily={theme.fonts.family.opensans.regular}
            />
            <TextDefault
              fontSize={10}
              color={theme.colors(appTheme).green[900]}
              text={`${item.appreciation}%`}
              fontFamily={theme.fonts.family.opensans.semi_bold}
            />
          </S.Row>
        )}
        <S.Row>
          <TextDefault
            fontSize={12}
            color={theme.colors(appTheme).white}
            text="Vendedor"
            fontFamily={theme.fonts.family.opensans.regular}
          />
          <TextDefault
            fontSize={10}
            color={theme.colors(appTheme).white}
            text={item.user_name || ''}
            fontFamily={theme.fonts.family.opensans.semi_bold}
          />
        </S.Row>
        {item.auctions_bids_value ? (
          <S.Row>
            <TextDefault
              fontSize={12}
              color={theme.colors(appTheme).white}
              text="Valor pago"
              fontFamily={theme.fonts.family.opensans.regular}
            />
            <TextDefault
              fontSize={10}
              color={theme.colors(appTheme).white}
              text={`R$ ${toPrice(item?.auctions_bids_value || 0, 2)}`}
              fontFamily={theme.fonts.family.opensans.semi_bold}
            />
          </S.Row>
        ) : (
          <>
            {item.bid?.id ? (
              <S.Row>
                <TextDefault
                  fontSize={12}
                  color={theme.colors(appTheme).white}
                  text="Último lance"
                  fontFamily={theme.fonts.family.opensans.regular}
                />
                <TextDefault
                  fontSize={10}
                  color={theme.colors(appTheme).white}
                  text={`${item.bid?.user_name} - R$ ${toPrice(
                    item?.bid?.value || 0,
                    2,
                  )}`}
                  fontFamily={theme.fonts.family.opensans.semi_bold}
                />
              </S.Row>
            ) : null}
            <S.Row>
              <TextDefault
                fontSize={12}
                color={theme.colors(appTheme).white}
                text="Tempo da oferta"
                fontFamily={theme.fonts.family.opensans.regular}
              />
              {timeGavel <= 0 ? (
                <TextDefault
                  fontSize={10}
                  color={theme.colors(appTheme).red[600]}
                  text="Leilão encerrado"
                  fontFamily={theme.fonts.family.opensans.semi_bold}
                />
              ) : (
                <TextDefault
                  fontSize={10}
                  color={theme.colors(appTheme).white}
                  text={lightFormat(
                    addHours(new Date(item?.offers_end_at), 3),
                    'dd/MM/yyyy HH:mm',
                  )}
                  fontFamily={theme.fonts.family.opensans.semi_bold}
                />
                // <CountDown
                //   until={differenceInSeconds(
                //     addHours(new Date(item?.offers_end_at), 3),
                //     new Date(),
                //   )}
                //   size={10}
                //   digitStyle={{backgroundColor: theme.colors(appTheme).white}}
                //   digitTxtStyle={{color: theme.colors(appTheme).main[800]}}
                //   timeLabelStyle={{color: theme.colors(appTheme).white}}
                //   timeToShow={['D', 'H', 'M', 'S']}
                //   timeLabels={{
                //     d: 'Dias',
                //     h: 'Horas',
                //     m: 'Minutos',
                //     s: 'Segundos',
                //   }}
                // />
              )}
            </S.Row>
            <S.Row style={{justifyContent: 'flex-end'}}>
              {item.user_id === userInfo?.user?.id &&
              item?.bid?.value &&
              item?.type === 'direta' &&
              !item?.blocked_at ? (
                <Button
                  title="ACEITAR TROCA"
                  onPress={() => {
                    acceptTrade(item);
                  }}
                  fontFamily={theme.fonts.family.opensans.bold}
                  width={120}
                  height={35}
                  marginTop={20}
                  style={{alignSelf: 'center'}}
                  fontSize={10}
                  isLoading={isLoading}
                />
              ) : null}
              {item.user_id === userInfo?.user?.id ||
              item?.blocked_at ||
              !applyBid ||
              timeGavel <= 0 ? null : (
                <Button
                  title="DAR LANCE"
                  onPress={applyBid}
                  fontFamily={theme.fonts.family.opensans.bold}
                  width={80}
                  height={35}
                  marginTop={20}
                  style={{alignSelf: 'center'}}
                  fontSize={10}
                />
              )}
            </S.Row>
          </>
        )}
      </S.Column>
    </S.Item>
  );
}

export default GavelItem;
